import { createFileRoute } from '@tanstack/react-router';
import { CrmPreviewPage } from '@/pages/Crm/CrmPreviewPage';
import { AclRoute, withPermission } from '@/lib/acl';
import { crmNavItem } from '@/lib/crm/crm-nav';

function Preview() {
  return <CrmPreviewPage navId="my-work" />;
}

export const Route = createFileRoute('/crm/my-work')({
  component: withPermission(Preview, { key: crmNavItem('my-work').access, route: AclRoute.CRM, resourceLabel: 'My work' }),
});
